{
  "close": "Închideţi"
}
